import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { DatePicker, Loadable, EntitySelector } from "components/support";

import Moment from "moment";

class SalesmanSalesReportFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: props.filters.dateFrom,
      dateTo: props.filters.dateTo,
      closeWorkaround: false
    };
  }

  static sReportTypes = [{ value: "summary", label: "Resumido" }];

  handleChange = ({ startDate, endDate, reportType }) => {
    const { onChange } = this.props;
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    this.setState(options);

    if (reportType) {
      onChange({ reportType });
    }
  };

  handleClose = () => {
    const { onChange } = this.props;
    this.setState({ closeWorkaround: !this.state.closeWorkaround }, () => {
      onChange({
        dateFrom: this.state.dateFrom,
        dateTo: this.state.dateTo
      });
    });
  };

  render() {
    const {
      loading,
      productSearchOptions,
      userSearchOptions,
      product,
      user,
      onSelectProduct,
      onSelectUser
    } = this.props;
    const { dateFrom, dateTo } = this.state;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={dateFrom}
                endDate={dateTo}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
                onClose={this.handleClose}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6} md>
              <EntitySelector
                label="Produto"
                title="Selecionar Produto"
                value={product.name}
                searchOptions={productSearchOptions}
                onSelect={product => onSelectProduct(product)}
                parser={product => ({ key: product.uuid, title: product.name })}
                nullSelection={{ name: "", uuid: null }}
              />
            </Col>
            <Col xs={6} md>
              <EntitySelector
                nullSelection={{ name: "", uuid: null }}
                label="Vendedor"
                title="Selecionar Vendedor"
                value={user.name}
                searchOptions={userSearchOptions}
                onSelect={user => onSelectUser(user)}
                parser={user => ({ key: user.uuid, title: user.name })}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default SalesmanSalesReportFilter;



// WEBPACK FOOTER //
// ./src/components/app/management/product-sales-report/filter/index.jsx